// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fDSn","question":"styles_question__2AfZ3","description":"styles_description__1EQqX"};